import { render, staticRenderFns } from "./layoutM.vue?vue&type=template&id=52bce0ed&scoped=true"
import script from "./layoutM.vue?vue&type=script&lang=js"
export * from "./layoutM.vue?vue&type=script&lang=js"
import style0 from "./layoutM.vue?vue&type=style&index=0&id=52bce0ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bce0ed",
  null
  
)

export default component.exports